import api from './api';

export interface Subcategory {
  id: string;
  name_french: string;
  name_english: string;
  category_id: string;
}

export const subcategoriesService = {
  async getSubcategories(): Promise<Subcategory[]> {
    try {

      const response = await api.get('/subcategories');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getSubcategoriesByCategory(categoryId: string): Promise<Subcategory[]> {
    try {
      const response = await api.get(`/subcategories/by-category/${categoryId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getSubcategory(id: string): Promise<Subcategory> {
    try {
      const response = await api.get(`/subcategories/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default subcategoriesService;
